// Cross-tab tenant switch sync via localStorage.
//
// We broadcast when `switchTenant` succeeds so other tabs can warn the user that their
// tenant context has changed server-side (it is derived from the user's last accessed tenant).

export const TENANT_SWITCH_STORAGE_KEY = '__sentry_tenant_switch__';

export const broadcastTenantSwitch = (tenantId) => {
	if (!tenantId || typeof window === 'undefined') {
		return;
	}

	try {
		window.localStorage.setItem(TENANT_SWITCH_STORAGE_KEY, JSON.stringify({
			tenantId: String(tenantId),
			timestamp: Date.now(),
		}));
	}
	catch (error) {
		// Ignore storage errors (private mode, quota, disabled storage, etc).
	}
};

export const parseTenantSwitchPayload = (rawValue) => {
	if (!rawValue || typeof rawValue !== 'string') {
		return null;
	}

	try {
		const payload = JSON.parse(rawValue);
		const tenantId = payload?.tenantId ? String(payload.tenantId) : null;
		const timestamp = payload?.timestamp;

		if (!tenantId || typeof timestamp !== 'number') {
			return null;
		}

		return { tenantId, timestamp };
	}
	catch (error) {
		return null;
	}
};

